import styled from '@emotion/styled';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

export const ModalContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 1.75rem;
  .css-136krjb button {
    flex-shrink: 1;
  }
`;

export const ElementsList = styled.ul<{ isMobile: boolean }>`
  column-width: 8rem;
  column-count: ${props => (props.isMobile ? 1 : 3)};
  column-gap: 2rem;
  row-gap: 0.5rem;
  padding-left: 1.5rem;
  margin: 0;
`;

export const ListElement = styled.li`
  margin-bottom: 0.5rem;
`;

export const MoreInfoAccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 1.5rem 0 1.5rem;

  @media screen and (max-width: ${MobileBreakpoint}px) {
    padding: 1rem 1rem 0 1rem;
  }
`;

export const DoctorAvatarInfoContainer = styled.div`
  @media screen and (min-width: 577px) {
    display: grid;
    grid-template-columns: 1fr 4fr;
    column-gap: 1rem;
  }
  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const DoctorInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const InfoRowContainer = styled.div`
  @media screen and (min-width: 577px) {
    display: grid;
    grid-template-columns: 1fr 2fr;
    column-gap: 0.5rem;
    align-items: start;
  }
  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
  }
`;

export const AcceptedInsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
`;

export const CustMessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
